<template>
  <v-app class="default-gradient-bg">
    <router-view />
  </v-app>
</template>

<script setup>
  //
</script>
